var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 2",
    viewBox: "0 0 35 35",
    id: "instagram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.37,34.75H9.63A9.39,9.39,0,0,1,.25,25.37V9.63A9.39,9.39,0,0,1,9.63.25H25.37a9.39,9.39,0,0,1,9.38,9.38V25.37A9.39,9.39,0,0,1,25.37,34.75ZM9.63,2.75A6.89,6.89,0,0,0,2.75,9.63V25.37a6.89,6.89,0,0,0,6.88,6.88H25.37a6.89,6.89,0,0,0,6.88-6.88V9.63a6.89,6.89,0,0,0-6.88-6.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 26.53a9 9 0 1 1 9-9A9 9 0 0 1 17.5 26.53zM17.5 11A6.53 6.53 0 1 0 24 17.5 6.54 6.54 0 0 0 17.5 11zM26.52 9.84a1.5 1.5 0 0 0 0-3 1.5 1.5 0 0 0 0 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c507ce8029690773a9cf826de0a4aed4.svg";
export { ForwardRef as ReactComponent };